import api from '../api';

export const submitFeedback = async (questionId, type) => {
    try {
        const response = await api.post('/api/submitFeedback', {
            questionId,
            type
        });
        console.log('Feedback submitted:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error submitting feedback:', error);
        throw error;
    }
};

export const submitSuggestion = async (suggestion, type = 'question') => {
    try {
        console.log('Service sending:', { suggestion, type });
        await api.post('/api/submitSuggestion', {
            suggestion,
            type
        });
    } catch (error) {
        console.error('Error submitting suggestion:', error);
        throw error;
    }
};
